import {Box, tempo} from '@tempo/core';

export const IFrame = tempo(Box);

IFrame.defaultProps = {
	as: 'iframe',
	loading: 'lazy',
};
